import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

/**
 * The choice the refusal offers instead of a dead end: proceed anyway, or go back and change the
 * klasse, datum or niveau (#179). Shared across create, edit and baan-toevoegen, whose only
 * difference is what "doorgaan" resubmits.
 */
export function DuplicaatWaarschuwingDialog({
  bericht,
  onOpenChange,
  onDoorgaan,
}: {
  bericht: string | null;
  onOpenChange: (open: boolean) => void;
  onDoorgaan: () => void;
}) {
  const { t } = useTranslation("wedstrijden");

  return (
    <AlertDialog open={bericht !== null} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("dagForm.duplicaatTitle")}</AlertDialogTitle>
          <AlertDialogDescription>{bericht}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t("dagForm.duplicaatAanpassen")}</AlertDialogCancel>
          <AlertDialogAction onClick={onDoorgaan}>
            {t("dagForm.duplicaatDoorgaan")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
